(() => {
  const normalize = value => String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const categoryReturnKey = 'tm-category-locale-return';
  const categoryPath = /\/collections\/skincare\/(tr-cat-[a-z-]+)\/?$/;
  let serial = 0;

  function restoreCategoryAfterLocalization() {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(categoryReturnKey) || 'null');
      sessionStorage.removeItem(categoryReturnKey);
    } catch { return; }
    if (!pending || Date.now() - pending.time > 15000 || !/^\/[\w/-]+(?:\?[^#]*)?$/.test(pending.path)) return;
    if (location.pathname + location.search === pending.path) return;
    const language = document.querySelector('#TrauemyLanguage')?.value;
    const country = document.querySelector('#TrauemyCountry')?.value;
    const currentBase = location.pathname.replace(/\/$/, '');
    const targetBase = pending.path.split('?')[0].replace(categoryPath, '/collections/skincare');
    if (language === pending.language && country === pending.country && currentBase === targetBase) location.replace(pending.path);
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.tm-locale-form')) return;
    const match = location.pathname.match(categoryPath);
    if (!match) return;
    const language = form.querySelector('#TrauemyLanguage');
    const country = form.querySelector('#TrauemyCountry');
    const root = language?.selectedOptions[0]?.dataset.root;
    if (!language?.value || !country?.value || root === undefined) return;
    const path = `${root.replace(/\/$/, '')}/collections/skincare/${match[1]}${location.search}`;
    try { sessionStorage.setItem(categoryReturnKey, JSON.stringify({ path, language: language.value, country: country.value, time: Date.now() })); }
    catch { /* Native Shopify localization still works without session storage. */ }
  }, true);

  restoreCategoryAfterLocalization();

  function displayName(locale, kind, code) {
    try { return new Intl.DisplayNames([locale], { type: kind }).of(code) || ''; }
    catch { return ''; }
  }

  function enhance(select) {
    if (select.dataset.tmSearchReady || select.disabled || select.options.length < 2) return;
    const nativeLabel = select.closest('label');
    const form = select.form;
    const details = select.closest('.tm-locale');
    if (!nativeLabel || !form || !details) return;

    const labelText = nativeLabel.firstChild?.textContent.trim() || select.name;
    const kind = select.dataset.searchKind;
    const id = `tm-locale-search-${++serial}`;
    const widget = document.createElement('div');
    widget.className = 'tm-locale-search';
    const label = document.createElement('span');
    label.className = 'tm-locale-search-label';
    label.id = `${id}-label`;
    label.textContent = labelText;
    const trigger = document.createElement('button');
    trigger.className = 'tm-locale-search-trigger';
    trigger.type = 'button';
    trigger.setAttribute('aria-labelledby', `${label.id} ${id}-value`);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', `${id}-panel`);
    const value = document.createElement('span');
    value.id = `${id}-value`;
    const chevron = document.createElement('span');
    chevron.className = 'tm-locale-search-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.textContent = '⌄';
    trigger.append(value, chevron);

    const panel = document.createElement('div');
    panel.className = 'tm-locale-search-panel';
    panel.id = `${id}-panel`;
    panel.hidden = true;
    const input = document.createElement('input');
    input.className = 'tm-locale-search-input';
    input.type = 'search';
    input.autocomplete = 'off';
    input.spellcheck = false;
    input.placeholder = form.dataset.searchPlaceholder || '';
    input.setAttribute('aria-label', `${labelText}: ${input.placeholder}`);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', `${id}-list`);
    const status = document.createElement('p');
    status.className = 'tm-locale-search-status';
    status.id = `${id}-status`;
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    input.setAttribute('aria-describedby', status.id);
    const list = document.createElement('div');
    list.className = 'tm-locale-search-results';
    list.id = `${id}-list`;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', labelText);
    panel.append(input, status, list);
    widget.append(label, trigger, panel);

    const browserLocale = document.documentElement.lang || 'en';
    const records = [...select.options].map((option, index) => {
      const code = option.value;
      const display = option.textContent.trim();
      const countryName = kind === 'country' ? display.split(' · ')[0] : '';
      const currency = kind === 'country' ? (display.match(/\b[A-Z]{3}\b/) || [])[0] || '' : '';
      const aliases = [display, code, countryName, currency];
      if (kind === 'country') aliases.push(displayName('en', 'region', code), displayName(browserLocale, 'region', code));
      if (kind === 'language') aliases.push(displayName('en', 'language', code), displayName(browserLocale, 'language', code));
      if (code === 'GB') aliases.push('UK', 'Britain');
      if (code === 'US') aliases.push('USA', 'United States');
      return { index, code, display, currency, searchable: aliases.map(normalize).filter(Boolean) };
    });
    let visible = records;
    let active = -1;

    function setValue() {
      value.textContent = select.selectedOptions[0]?.textContent.trim() || form.dataset.searchChoose || '';
    }
    function activate(index) {
      active = index;
      [...list.children].forEach((row, position) => row.classList.toggle('is-active', position === index));
      const row = list.children[index];
      if (row) {
        input.setAttribute('aria-activedescendant', row.id);
        row.scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }
    function render() {
      const query = normalize(input.value);
      const terms = query.split(' ').filter(Boolean);
      visible = records.filter(record => !terms.length || terms.every(term => record.searchable.some(alias => alias.includes(term))));
      if (query) visible.sort((a, b) => {
        const score = record => record.code.toLowerCase() === query ? 0 : record.searchable.some(alias => alias === query) ? 1 : record.searchable.some(alias => alias.startsWith(query)) ? 2 : 3;
        return score(a) - score(b) || a.index - b.index;
      });
      else visible.sort((a, b) => Number(b.code === select.value) - Number(a.code === select.value) || a.index - b.index);
      list.replaceChildren();
      active = -1;
      input.removeAttribute('aria-activedescendant');
      for (const record of visible) {
        const row = document.createElement('div');
        row.className = 'tm-locale-search-option';
        row.id = `${id}-option-${record.index}`;
        row.dataset.value = record.code;
        row.setAttribute('role', 'option');
        row.setAttribute('aria-selected', String(record.code === select.value));
        const name = document.createElement('span');
        name.textContent = record.display;
        const code = document.createElement('small');
        code.textContent = record.code;
        row.append(name, code);
        list.append(row);
      }
      status.textContent = visible.length ? (form.dataset.searchResults || '__COUNT__').replace('__COUNT__', String(visible.length)) : form.dataset.searchEmpty || '';
    }
    function close(restoreFocus = false) {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (restoreFocus) trigger.focus();
    }
    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      input.setAttribute('aria-expanded', 'true');
      input.value = '';
      render();
      input.focus();
    }
    function choose(record) {
      if (!record) return;
      select.value = record.code;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      setValue();
      close(true);
    }

    trigger.addEventListener('click', () => panel.hidden ? open() : close());
    input.addEventListener('input', render);
    input.addEventListener('keydown', event => {
      if (event.isComposing || !['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', 'Escape'].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.key === 'Escape') return close(true);
      if (event.key === 'Enter') return choose(visible[active] || (visible.length === 1 ? visible[0] : null));
      if (!visible.length) return;
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : event.key === 'ArrowDown' ? Math.min(active + 1, visible.length - 1) : active < 0 ? visible.length - 1 : Math.max(active - 1, 0);
      activate(next);
    });
    list.addEventListener('pointerdown', event => event.preventDefault());
    list.addEventListener('click', event => choose(visible.find(record => record.code === event.target.closest('[role="option"]')?.dataset.value)));
    document.addEventListener('pointerdown', event => { if (!widget.contains(event.target)) close(); });
    details.addEventListener('toggle', () => { if (!details.open) close(); });
    select.addEventListener('change', setValue);
    nativeLabel.after(widget);
    nativeLabel.hidden = true;
    select.dataset.tmSearchReady = 'true';
    setValue();
  }

  function init() { document.querySelectorAll('.tm-locale-form select[data-search-kind]').forEach(enhance); }
  document.addEventListener('shopify:section:load', init);
  init();
})();
